module.exports = __webpack_public_path__ + "img/qr_code2.de41b36e.png";